import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// Navigation context removed to fix errors
import { WalletContextProvider } from './components/WalletContextProvider';
import { GameProvider } from './game/context/GameContext';
import { AuctionStateProvider } from './context/AuctionStateContext';
import { ContributionProvider } from './context/ContributionContext';
import { AffiliateProvider } from './context/AffiliateContext';
import { CleanAuctionProvider } from './context/CleanAuctionContext';
import { BalanceProvider } from './context/BalanceContext';
import { WhitelistProvider } from './context/WhitelistContext';
import { DiscordProvider } from './context/DiscordContext';
import AppContent from './AppContent';
import theme from './theme';
import './index.css';
import SEO from './components/SEO';

import ModularUserProfile from './pages/UserProfile/ModularUserProfile';
import Analytics from './pages/Analytics';
// TestWhitelistGuard removed
import WhitelistGuard from './components/WhitelistGuard';
import Auction from './pages/Auction';
import Layout from './components/Layout';
import { UserProvider } from './context/UserContext';
import { AuctionProvider } from './context/AuctionContext';

// Import wallet adapter styles
import '@solana/wallet-adapter-react-ui/styles.css';
import './wallet-button-override.css';

function App() {
    return (
        <ChakraProvider theme={theme}>
            <WalletContextProvider>
                <Router>
                        {/* 
                          * Using the new modular context architecture
                          * AuctionStateContext: Core auction state
                          * ContributionProvider: User contributions and rewards
                          * AffiliateProvider: Referral tracking and rewards
                          * CleanAuctionProvider: Provides backward compatibility with useAuction
                          */}
                        <AuctionStateProvider>
                        <ContributionProvider>
                            <AffiliateProvider>
                                <CleanAuctionProvider>
                                    <BalanceProvider>
                                        <WhitelistProvider>
                                            <GameProvider>
                                                <DiscordProvider>
                                                    <SEO />
                                                    <Routes>
                                                        <Route path="/modular-profile" element={<ModularUserProfile />} />
                                                        <Route path="/analytics" element={<Analytics />} />
                                                        {/* TestWhitelistGuard route removed */}
                                                        <Route path="/direct-auction" element={
                                                            <UserProvider>
                                                                <AuctionProvider>
                                                                    <WhitelistGuard>
                                                                        <Layout>
                                                                            <Auction />
                                                                        </Layout>
                                                                    </WhitelistGuard>
                                                                </AuctionProvider>
                                                            </UserProvider>
                                                        } />
                                                        <Route path="*" element={<AppContent />} />
                                                    </Routes>
                                                </DiscordProvider>
                                            </GameProvider>
                                        </WhitelistProvider>
                                    </BalanceProvider>
                                </CleanAuctionProvider>
                            </AffiliateProvider>
                        </ContributionProvider>
                    </AuctionStateProvider>
                </Router>
            </WalletContextProvider>
        </ChakraProvider>
    );
}

export default App;
